import * as React from 'react';
import { Col, Row } from 'reactstrap';
import cl4 from 'src/assets/homeOperation/cl4.png';
import cl1 from 'src/assets/homeOperation/Consultant1.png';
import cs2 from 'src/assets/homeOperation/Consultant2.png';
import cs2xs from 'src/assets/homeOperation/Consultant2xs.png';
import cl5 from 'src/assets/homeOperation/CS5.png';
import cl3 from 'src/assets/homeOperation/Shared3.png';

export const HomeOperationConsultant: React.SFC<{}> = () => (
  <>
{/************************  Ligne 1  ******************************/}
  <Row className='d-flex justify-content-center'>
    <Col sm='4' xs='12'className='d-flex flex-column order-2 order-sm-1 mt-3  px-0' >
      <p className='HomeOperationConsultantTextLn1'  style={{ backgroundColor: 'rgba(255,255,255, 0.5)' }}>
        Vous{' '}<strong className='text-secondary'>recherchez une mission</strong> qui corresponde <br/>à votre expertise avec une facturation transparente.
      </p>
      <svg className='w-120 mt-auto  d-none d-sm-block' height='5'>
        <line  x1="0" x2="1000" y1="0" y2="0" stroke-linecap="square" stroke="#c5eaff" stroke-width="10"  />
      </svg>
    </Col>
    <Col sm='4' xs='12'className='d-flex order-1 order-sm-2  mt-4 mt-sm-auto  px-0' >  
      <svg style={{marginLeft:'-40px'  }}  height='5' className='mt-auto d-none d-sm-block'>
        <line  x1="0" x2="1000" y1="0" y2="0" stroke-linecap="square" stroke="rgb(188, 235, 253)" stroke-width="11"  />
      </svg>
      <img className='mt-auto mx-auto mx-sm-0' height="160" width="auto"  src={cl1}/>
      <svg height='5'  className='mt-auto d-none d-sm-block'  >
        <line  x1="0" y1="0" x2="300" y2="0" stroke-linecap="square" stroke="rgb(188, 235, 253)" stroke-width="11"  />
      </svg>
      <span  >
        <svg   height="219"  width='5' className='d-none d-sm-block'>
          <line  x1="0" y1="0" x2="0"  y2="400" stroke-linecap="square" stroke="rgb(188, 235, 253)" stroke-width="11"  />
        </svg>
      </span>
    </Col>
  </Row>
{/************************  Ligne 2  ******************************/}
<Row className='d-flex justify-content-center align-items-end'>
  <Col sm='4' xs='12' className='d-flex justify-content-center mt-5 mt-sm-auto px-0' >
    <span>
      <svg  height='228'  width='5'  className='d-none d-sm-block' >
        <line x1="0" x2="0" y1="0" y2="500" stroke-linecap="square" stroke="#c5eaff" stroke-width="10"  />
      </svg>
    </span>
    <svg  className='mt-auto d-none d-sm-block' height='6'  >
     <line  x1="0" x2="400" y1="0" y2="0" stroke-linecap="square" stroke="#c5eaff" stroke-width="12"  />
    </svg>

    <img className='mt-auto d-none d-sm-block' width='auto' height='170px' src={cs2}/>
    <img className='mt-auto d-sm-none' width='auto' height='170px' src={cs2xs}/>
    
    <svg className='mt-auto d-none d-sm-block' height='5' >
      <line  x1="0" x2="200" y1="0" y2="0" stroke-linecap="square" stroke="#c5eaff" stroke-width="10"  />
    </svg>
  </Col>

  <Col sm='4' xs='12' className=' mt-3 px-0'>
   
      <Row className='px-0 mx-0'>
        <Col className='d-flex px-0 '>
          <p className='HomeOperationConsultantTextLn2'  style={{ backgroundColor: 'rgba(255,255,255, 0.5)' }}>
              Les équipes BeAdvize{' '}
              <strong className='text-secondary'>vous contactent</strong> rapidement
            pour{' '}
            <strong className='text-secondary'>
              définir avec vous votre recherche de mission
            </strong>{' '}
            avec une revue de vos compétences et expériences, et une{' '}
              <strong className='text-secondary'>
                définition très précise de votre ciblage métier et tarifaire.
              </strong>
            </p>
        </Col>
      </Row>

      <Row className='d-flex mx-0 px-0'>
         <Col sm='9' className='px-0' >
            <svg /* style={{marginLeft: '-50px'}} */ className='mt-auto d-none d-sm-block w-100'  height='5' >
              <line  x1="0" x2="800" y1="0" y2="0" stroke-linecap="square" stroke="#c5eaff" stroke-width="10"  />
            </svg>
          </Col>
          <Col sm='3' className='px-0'/>
      </Row>
  </Col>
</Row>

{/************************  Ligne 3  ******************************/}   
<Row className='d-flex justify-content-center' >
    <Col sm='4' xs='12' className='order-2 order-sm-1 mt-3 mt-sm-0 px-0 '>
        
        <p  className='HomeOperationConsultantTextLn3' style={{ backgroundColor: 'rgba(255,255,255, 0.5)' }}>
          Votre recherche est étudiée par nos équipes et nous vous proposons{' '}
          <strong className='text-secondary'>
            des appels d'offre qui correspondent parfaitement à votre recherche
            de mission.
          </strong>{' '}
          <br />À vous de définir votre réponse en terme de méthodologie et de
          tarif.
          <br />
          Les équipes BeAdvize vous accompagnent bien sûr durant toute cette
          étape.
        </p>
      </Col>    

    <Col sm='4' xs='12' className='d-flex order-1 order-sm-2 mt-5 mt-sm-0 px-0'>
       
        <Col sm='9' className='d-flex flex-column align-items-end px-0 '>
        
          <svg height='50' width='5'  className='d-none d-sm-block' >
            <line x1="0" x2="0" y1="0" y2="100" stroke-linecap="square" stroke="#c5eaff" stroke-width="10"  />
          </svg>
          <img  style={{marginRight: '-105px'}}  width='189px' height='162px' src={cl3}/>
        
        </Col>

        <Col sm='3' className='px-0'/>
      </Col>


</Row>

{/************************  Ligne 4  ******************************/}    
<Row className='d-flex justify-content-center'>
  
  <Col sm='4' xs='12' className='d-flex  justify-content-center  justify-content-sm-end  order-2 order-sm-1 mt-3 mt-sm-auto px-0 '>
    <p  className='HomeOperationConsultantTextLn4'  style={{ backgroundColor: 'rgba(255,255,255, 0.5)' }}>
    <strong className='text-secondary'>Le projet peut commencer</strong> ,<br />
    en utilisant les fonctionnalités
    <br />
    d'échange et de suivi de BeAdvize.
    </p>
  </Col>
  
  <Col sm='4' xs='12' className='d-flex justify-content-center justify-content-sm-start order-1 order-sm-2 mt-5 mt-sm-auto px-0 '>
    <Col sm='9' className='d-flex align-items-sm-start justify-content-center px-0'>
      <img className='HomeOperationConsultantPicLn4 mt-auto' height="160" width="auto" src={cl4}/>
      <svg className='mt-auto d-none d-sm-block ' height='5'  style={{marginBottom: '50px'}} >
          <line  x1="0" x2="500" y1="0" y2="0" stroke-linecap="square" stroke="#c5eaff" stroke-width="10"  />
      </svg>
      <span>
        <svg style={{marginBottom: '50px'}} height='178' width='5'  className='d-none d-sm-block' >
          <line x1="0" x2="0" y1="0" y2="300" stroke-linecap="square" stroke="#c5eaff" stroke-width="10"  />
        </svg>
      </span>
    </Col>
    <Col sm='3' className='d-none d-sm-block px-0' />
  </Col>

</Row>

{/************************  Ligne 5  ******************************/}
<Row className='d-flex justify-content-center'>
 <Col sm='4' xs='12' className='d-flex flex-column align-items-center mt-5 mt-sm-auto px-0'>
   <svg height='130' width='14' className='d-none d-sm-block' >
    <line x1="0" x2="0" y1="0" y2="150" stroke-linecap="square" stroke="#c5eaff" stroke-width="10"  />
   </svg>
   <img   height="auto" width="287" src={cl5}/>
 </Col>
 <Col xs='12' className='text-center mt-3 px-0'>
 <p style={{ backgroundColor: 'rgba(255,255,255, 0.5)' }}>
          Une fois le projet terminé,
           <br />
           vous <strong className='text-secondary'>évaluez le projet</strong> et
           vous recevez votre{' '}
          <strong className='text-secondary'>paiement.</strong>
         </p>
 </Col>
</Row>
</>
);




// WEBPACK FOOTER //
// ./src/components/HomePage/HomeOperation/HomeOperationConsultant.tsx